module.exports = __webpack_public_path__ + "img/sld_grid_ta1_dark.321d82fa.svg";